import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { HR } from '../HR';
import { jsx as _jsx } from "react/jsx-runtime";
export const DropdownDivider = _ref => {
  let rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(HR, Object.assign({
    distance: "xs",
    backgroundColor: "border-transitional-core-subtle"
  }, rest));
};